import { UserMode } from "../enums";

export class TicketUserModeResult {
    public userMode: UserMode;
    public ticketUserMode: UserMode;
    public commentCount: number;

    constructor() {
        this.userMode = UserMode.CustomerEmployee,
        this.ticketUserMode = UserMode.CustomerEmployee,
        this.commentCount = 0
    }
}